import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// inside Login.jsx, replace your `styles` placeholder with this:

const styles = {
  container: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f5f5f5",
    padding: "2rem",
  },
  card: {
    width: "100%",
    maxWidth: "400px",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    padding: "2rem",
  },
  title: {
    marginBottom: "1.5rem",
    fontSize: "1.75rem",
    textAlign: "center",
    color: "#111",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  label: {
    display: "flex",
    flexDirection: "column",
    fontSize: "0.9rem",
    color: "#333",
  },
  input: {
    marginTop: "0.25rem",
    padding: "0.75rem 1rem",
    fontSize: "1rem",
    borderRadius: "4px",
    border: "1px solid #ccc",
    outline: "none",
    transition: "border-color 0.2s",
  },
  inputFocus: {
    borderColor: "#f43f5e",  // match your CTA color
  },
  button: {
    marginTop: "1rem",
    padding: "0.75rem",
    fontSize: "1rem",
    fontWeight: "bold",
    color: "#fff",
    background: "#f43f5e",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "background 0.2s",
  },
  buttonHover: {
    background: "#e11d48",
  },
  error: {
    marginTop: "1rem",
    color: "#e11d48",
    textAlign: "center",
    fontSize: "0.9rem",
  },
};


const Login = () => {
  const [email, setEmail]             = useState("");
  const [password, setPassword]       = useState("");
  const [error, setError]             = useState("");
  const [isLoading, setIsLoading]     = useState(false);
  const navigate                      = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // ⬇️ quick offline fallback
    if (email === "test@example.com" && password === "password") {
      localStorage.setItem("token", "dummy");
      navigate("/");          // back to the home page
      return;
    }

    setIsLoading(true);
    try {
      const api = "https://qf-v1.onrender.com";
      const form = new URLSearchParams();
      form.append("username", email);
      form.append("password", password);
      // (Optionally) form.append("grant_type", "");
      const res = await fetch(`${api}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: form.toString(),
      });

      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.detail ?? "Login failed");
      }
      const { access_token } = await res.json();
      localStorage.setItem("token", access_token);
      navigate("/");
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

return (
  <div style={styles.container}>
    <div style={styles.card}>
      <h2 style={styles.title}>QuickFit Login</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        {/* Email */}
        <label style={styles.label}>
          Email
          <input
            type="email"
            style={styles.input}
            onFocus={e => e.currentTarget.style.borderColor = styles.inputFocus.borderColor}
            onBlur={e => e.currentTarget.style.borderColor = "#ccc"}
            placeholder="you@example.com"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
        </label>

        {/* Password */}
        <label style={styles.label}>
          Password
          <input
            type="password"
            style={styles.input}
            onFocus={e => e.currentTarget.style.borderColor = styles.inputFocus.borderColor}
            onBlur={e => e.currentTarget.style.borderColor = "#ccc"}
            placeholder="••••••••"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </label>

        {/* Submit */}
        <button
          type="submit"
          style={styles.button}
          onMouseEnter={e => e.currentTarget.style.background = styles.buttonHover.background}
          onMouseLeave={e => e.currentTarget.style.background = styles.button.background}
          disabled={isLoading}
        >
          {isLoading ? "Logging in…" : "Login"}
        </button>
      </form>
      {error && <p style={styles.error}>{error}</p>}
    </div>
  </div>
);

};

export default Login;
